import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-882aa79e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "plan_name ion-text-lowercase"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "ion-text-capitalize" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 8 }

import { IClientPaymentPlanParams } from "@/models/plan";
import {
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonProgressBar,
  IonSkeletonText,
  IonText,
  useIonRouter,
  onIonViewWillEnter,
} from "@ionic/vue";
import { onBeforeMount, reactive, watch } from "vue";
import { useUserStore } from "@/stores/user";
import { usePlansStore } from "@/stores/plans";
import { getSubscribedPlans } from "@/api/plans";
import { getClientAccount } from "@/api/clients";


export default /*#__PURE__*/_defineComponent({
  __name: 'BeamianPlan',
  setup(__props) {

const userStore = useUserStore();
const plansStore = usePlansStore();
const router = useIonRouter();

// const urlSubscriptionsFrontend = process.env.VUE_APP_SUBSCRIPTIONS_SERVER_PATH;
const state = reactive({
  loading: false,
  errors: {
    name: [],
    phone_number: [],
  },
  current_plan: {},
  current_billing_cicle: "",
  subscribed_plans: Array<IClientPaymentPlanParams>,
  next_charge_at: "",
  client_account: {},
  total_visitors: 0,
  successfull_purchase: false,
  revenue_plans: [],
});

onIonViewWillEnter(async () => {
  await loadPlanInformation();
});

onBeforeMount(async () => {
  await loadPlanInformation();
});
const loadPlanInformation = async () => {
  userStore.fetchRoles();
  await plansStore.fetch({ reset: true, page_size: 10 });
  // state.current_plan = plansStore.results[0];

  const plan = await getSubscribedPlans();
  state.subscribed_plans = plan.data.results;

  let current_plan_id = 0;

  state.subscribed_plans.forEach((element: any) => {
    if (element.subscription_status === "active") {
      state.current_billing_cicle = element.billing_cycle;
      state.next_charge_at = element.subscription_current_period_end;
      current_plan_id = element.payment_plan;
      return;
    }
  });

  // Get plan information
  const current_plan = await plansStore.fetchPlan(current_plan_id);
  state.current_plan = current_plan.result;
};

watch(
  () => userStore.related.clients,
  async (clients) => {
    if (userStore.related.clients.length) {
      const client_account = await getClientAccount(clients[0].id);
      state.client_account = client_account.data;
    }
  }
);

const getProgressResult = (existing: number, allowed: number) => {
  return existing / allowed;
};

const isValidNumber = (value: any) => {
  return typeof value === "number";
};

const openMySubscription = () => {
  router.push("/my-subscription");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { class: "ion-margin" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), { class: "ion-justify-content-end" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "ion-margin-start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonText), { color: "dark" }, {
                    default: _withCtx(() => [
                      (state.current_plan.name)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(state.current_plan.name), 1))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_2, [
                            _createVNode(_unref(IonSkeletonText), {
                              animated: true,
                              class: "billing_cicle_skeleton"
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  (state.next_charge_at && !state.current_plan.is_a_free_plan)
                    ? (_openBlock(), _createBlock(_unref(IonText), {
                        key: 0,
                        color: "dark",
                        class: "font-weight-400"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Next charge at: " + _toDisplayString(state.next_charge_at), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_3,
                  (
              state.current_billing_cicle && !state.current_plan.is_a_free_plan
            )
                    ? (_openBlock(), _createBlock(_unref(IonText), {
                        key: 1,
                        color: "dark",
                        class: "font-weight-400"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(state.current_billing_cicle), 1),
                          _createTextVNode(" subscription")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCol), {
                class: "freeplan",
                size: "3"
              }, {
                default: _withCtx(() => [
                  (state.current_plan.is_a_free_plan)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        size: "large",
                        fill: "clear",
                        color: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("FREE")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              !state.current_plan.is_a_free_plan &&
              state.current_billing_cicle === 'monthly' &&
              state.current_plan.monthly_price_eur > 0
            )
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 1,
                        size: "large",
                        fill: "clear",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("€" + _toDisplayString(state.current_plan.monthly_price_eur / 100), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              !state.current_plan.is_a_free_plan &&
              state.current_billing_cicle === 'annually' &&
              state.current_plan.annual_price_eur > 0
            )
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 2,
                        size: "large",
                        fill: "clear",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("€" + _toDisplayString(state.current_plan.annual_price_eur / 100), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          (state.client_account.owned_events)
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(state.client_account.owned_events?.length) + " of " + _toDisplayString(state.current_plan.check_in_max_events) + " Events ", 1))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 1,
                animated: true,
                style: {"width":"50%"}
              })),
          (state.client_account.owned_events)
            ? (_openBlock(), _createBlock(_unref(IonProgressBar), {
                key: 2,
                value: 
          getProgressResult(
            state.client_account.owned_events?.length,
            state.current_plan?.check_in_max_events
          )
        ,
                class: "ion-margin-top ion-margin-bottom"
              }, null, 8, ["value"]))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 3,
                class: "skeleton_limits",
                animated: true
              })),
          (isValidNumber(state.client_account.allocated_capacity))
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(state.client_account.allocated_capacity) + " of " + _toDisplayString(state.current_plan.check_in_max_capacity) + " Visitors ", 1))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 5,
                animated: true,
                style: {"width":"50%"}
              })),
          (isValidNumber(state.client_account.allocated_capacity))
            ? (_openBlock(), _createBlock(_unref(IonProgressBar), {
                key: 6,
                value: 
          getProgressResult(
            state.client_account.allocated_capacity,
            state.current_plan.check_in_max_capacity
          )
        ,
                class: "ion-margin-top ion-margin-bottom"
              }, null, 8, ["value"]))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 7,
                class: "skeleton_limits",
                animated: true
              })),
          (isValidNumber(state.client_account.event_managers))
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(state.client_account.event_managers) + " of " + _toDisplayString(state.current_plan.check_in_max_event_managers) + " Event Managers ", 1))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 9,
                animated: true,
                style: {"width":"50%"}
              })),
          (isValidNumber(state.client_account.event_managers))
            ? (_openBlock(), _createBlock(_unref(IonProgressBar), {
                key: 10,
                value: 
          getProgressResult(
            state.client_account.event_managers,
            state.current_plan.check_in_max_event_managers
          )
        ,
                class: "ion-margin-top ion-margin-bottom"
              }, null, 8, ["value"]))
            : (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                key: 11,
                class: "skeleton_limits",
                animated: true
              })),
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), { class: "ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    color: "primary",
                    class: "ion-margin-top",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (openMySubscription()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" MANAGE PLAN ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})